import React, { useState, useEffect } from 'react';
import { Modal, Button } from "react-bootstrap";
import Toast from "../Notify/Toast";
import "../../styles/bootstrap.min.css";
import axiosInstance from "../../utils/config";
function BizForm({ token }) {
  useEffect(() => {
    handleShow();
  }, [])
  const [show, setShow] = useState(false);
  const [toastMessage, setToast] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [creatingCategory, setCreatingCategory] = useState(false);

  const handleClose = (e) => {
    e.preventDefault();
    setShow(false)
  };
  const handleShow = () => setShow(true);

  const handleSubmit = (e) => {
    e.preventDefault();
    setCreatingCategory(true);
    const headers = { 
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    }
    axiosInstance
    .post("/category/new", { categoryName }, { headers })
    .then((data) => { 
      setToast(data.data.message)
      setCreatingCategory(false);
    })
    .catch((err) => {
      setToast(err.response.data)
      setCreatingCategory(false);
    })
  }

  return (
    <>
      {toastMessage && (<Toast message={toastMessage} />)}
      <Modal
        dialogClassName='w-25'
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>Add a new category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <input 
            type="text" 
            value={categoryName}
            className="form-control shadow-sm" 
            placeholder="Enter name of category"
            onChange={(e) => setCategoryName(e.target.value)}
            />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary btn-sm" onClick={handleClose}>
            Discard
          </Button>
          <Button variant="primary btn-sm" onClick={handleSubmit}>{creatingCategory ? "Creating..." : "Add +"}</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default BizForm;